import React, { type JSX } from 'react';
import {
  type HasViewModelBuilder,
  type ViewModelBuilder,
} from '../../typings/viewModelBuilder';
import useViewModel from '../../hooks/useViewModel';
import EnhancedMarkdownAbilityIcon from '@resources/js/components/EnhancedMarkdown/components/EnhancedMarkdownAbilityIcon';
import { type School } from '@resources/js/components/EnhancedMarkdown/helpers/abilitySchools';

type Props = {
  id: number;
  type?: School;
};

type AbilityViewModel = {
  id: number;
  name: string;
  icon: string;
};

export default function AbilityFromViewModel(props: Props): JSX.Element | null {
  const ability = useViewModel(
    props,
    viewModelBuilder.buildKey,
  ) as AbilityViewModel;

  if (!ability) {
    return (
      <EnhancedMarkdownAbilityIcon id={props.id} icon={''} type={props.type}>
        {props.id.toString()}
      </EnhancedMarkdownAbilityIcon>
    );
  }

  return (
    <EnhancedMarkdownAbilityIcon
      id={ability.id}
      icon={ability.icon}
      type={props.type}
    >
      {ability.name}
    </EnhancedMarkdownAbilityIcon>
  );
}

const viewModelBuilder: ViewModelBuilder<Props> = {
  buildKey: (props: Props) => `ability_${props.id}`,
  prebuild: (props, { graphQLViewModelQueries }) => {
    graphQLViewModelQueries.push({
      query: `ability(id: ${props.id})`,
      key: viewModelBuilder.buildKey(props),
    });
  },
  buildModel: (props, { graphQLViewModels }) =>
    graphQLViewModels[viewModelBuilder.buildKey(props)],
};

(
  AbilityFromViewModel as unknown as HasViewModelBuilder<Props>
).viewModelBuilder = viewModelBuilder;
